import { BASE_URL, security_key } from "../../global";
import React, { useState, useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const getStoredNotifications = (userKey) => {
    const stored = localStorage.getItem(`notifications_${userKey}`);
    return stored ? JSON.parse(stored) : [];
};

const setStoredNotifications = (userKey, notifications) => {
    localStorage.setItem(`notifications_${userKey}`, JSON.stringify(notifications));
};

const NotificationDropdown = () => {
    const [showNotifications, setShowNotifications] = useState(false);
    const [acNotification, setAcNotification] = useState([]);
    const [newArticle, setNewArticle] = useState([]);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const [hasNewNotifications, setHasNewNotifications] = useState(false);
    const userType = sessionStorage.getItem("user_type");
    const userKey = sessionStorage.getItem("pk_user_key");

    useEffect(() => {
        if (userType === "3") {
            getAcNotification();
            getArticleNotification();
        }
    }, [userType]);

    const toggleNotifications = () => {
        setShowNotifications((prev) => !prev);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowNotifications(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getAcNotification = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getShareAc",
                user_key: userKey,
            });

            const output = response.data;
            if (output.articles.length > 0) {
                const notification = output.notifications.reduce((not, notification) => {
                    not = notification.not_message;
                    return not;
                }, {});

                const notificationsWithAcLink = output.articles.map((article) => ({
                    ...article,
                    not_message: notification,
                }));

                setAcNotification(notificationsWithAcLink);
                if (notificationsWithAcLink.length > 0) {
                    setHasNewNotifications(true);
                }
            }
        } catch (error) {
            console.error("Error fetching shared notifications:", error);
        }
    };

    const getArticleNotification = async () => {
        try {
            if (userType === "3") {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "getNewArticleNotifications",
                });

                const output = response.data;
                const pk_ac_key = output.articles[0].pk_ac_key;
                if (output.notifications.length > 0) {
                    const articleNames = output.articles.reduce((acc, article) => {
                        acc = article.ac_name;
                        return acc;
                    }, {});

                    const notificationsWithAcName = output.notifications.map((notification) => ({
                        ...notification,
                        ac_name: articleNames,
                        pk_ac_key: pk_ac_key,
                    }));

                    setNewArticle(notificationsWithAcName);
                    setHasNewNotifications(true);
                }
            }
        } catch (error) {
            console.error("Error fetching new article notifications:", error);
        }
    };

    const updateNotificationStatus = async (notificationId) => {
        try {
            await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                pk_share_ac_key: notificationId,
                mode: "removeNotification",
            });

            const viewedNotifications = getStoredNotifications(userKey);
            viewedNotifications.push(notificationId);
            setStoredNotifications(userKey, viewedNotifications);
        } catch (error) {
            console.error("Error updating notification status:", error);
        }
    };

    const handleNotificationClick = (link, notificationId) => {
        window.open(link, "_top", "noopener,noreferrer");
        updateNotificationStatus(notificationId);
        setHasNewNotifications(false);
        setAcNotification((prevNotifications) => prevNotifications.filter((notification) => notification.pk_share_ac_key !== notificationId));
    };

    const handleArticleClick = (notificationId) => {
        const pk_ac_key = newArticle[0].pk_ac_key;
        navigate(`/detail/${pk_ac_key}`);
        updateNotificationStatus(notificationId);
        setHasNewNotifications(false);
        setNewArticle((prevNotifications) => prevNotifications.filter((notification) => notification.pk_ac_key !== notificationId));
    };

    const filteredAcNotification = acNotification.filter((notification) => !getStoredNotifications(userKey).includes(notification.pk_share_ac_key));

    const filteredNewArticle = newArticle.filter((notification) => !getStoredNotifications(userKey).includes(notification.pk_ac_key));

    const combinedNotifications = [...filteredAcNotification, ...filteredNewArticle];

    const showRedDot = combinedNotifications.length > 0 && hasNewNotifications;

    return (
        <div className="notification-container" ref={dropdownRef}>
            <Button variant="link" className="notification-icon text-dark" onClick={toggleNotifications}>
                <i className="fa-regular fa-bell fa-lg"></i>
                {showRedDot && <span className="notification-dot"></span>} {/* Red dot for new notifications */}
            </Button>

            {showNotifications && (
                <div className="notification-dropdown">
                    <ul className="notification-list">
                        {combinedNotifications.length > 0 ? (
                            combinedNotifications.map((notification) => (
                                <li key={notification.pk_share_ac_key || notification.id} className="notification-item">
                                    {acNotification.some((ac) => ac.pk_share_ac_key === notification.pk_share_ac_key) && `${notification.not_message}  - `}
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (notification.ac_name) {
                                                handleArticleClick(notification.pk_ac_key);
                                            } else {
                                                handleNotificationClick(notification.ac_link, notification.pk_share_ac_key);
                                            }
                                        }}
                                    >
                                        {acNotification.some((ac) => ac.pk_share_ac_key === notification.pk_share_ac_key)
                                            ? `${notification.ac_link}`
                                            : `${notification.not_message} - ${notification.ac_name}`}
                                        {acNotification.some((ac) => ac.pk_share_ac_key === notification.pk_share_ac_key) &&
                                            ` (Shared by ${notification.first_name} ${notification.last_name})`}
                                    </a>
                                </li>
                            ))
                        ) : (
                            <li className="notification-item">No notifications</li>
                        )}
                    </ul>
                </div>
            )}

            <style jsx>{`
                .notification-container {
                    position: relative;
                    display: inline-block;
                }

                .notification-icon {
                    cursor: pointer;
                    position: relative;
                }

                .notification-dot {
                    position: absolute;
                    top: 5px;
                    right: 12px;
                    width: 8px;
                    height: 8px;
                    background-color: red;
                    border-radius: 50%;
                    border: 2px solid white;
                }

                .notification-dropdown {
                    position: absolute;
                    top: 100%;
                    right: -80px;
                    background: #fff;
                    border: 1px solid #ddd;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    padding: 10px;
                    border-radius: 4px;
                    width: 200px;
                    z-index: 1000;
                    max-height: 150px;
                    overflow-y: auto;
                    text-align: start;
                }

                .notification-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                .notification-item {
                    padding: 10px;
                    border-bottom: 1px solid #ddd;
                }

                .notification-item:last-child {
                    border-bottom: none;
                }

                .notification-item:hover {
                    background-color: #f5f5f5;
                }
            `}</style>
        </div>
    );
};

export default NotificationDropdown;
